import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { UserInfoService } from './Services/Utilities/user-info.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmationDialogComponent } from './Shared/confirmation-dialog/confirmation-dialog.component';
import { MediaMatcher } from '@angular/cdk/layout';
import { DateFormatService } from './Services/Utilities/date-format.service';
import { AccountSettingsComponent } from './Components/account-settings/account-settings.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {


  login = false;
  ready = false;
  private mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;

  counttimer1 = ''
  counttimer2 = ''

  clear() {
    clearInterval(this.x);
    clearInterval(this.x2);
    this.counttimer1 = ''
    this.counttimer2 = ''
  }

  x;
  x2;

  role: string[];
  diasbleCountDown = false;
  time: any;

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router,
    private angularFireAuth: AngularFireAuth,
    private firestore: AngularFirestore,
    private userinfoSrv: UserInfoService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private dialog: MatDialog,
  ) {

    this.firestore.collection('Setting').doc('Deadline').get().forEach(e=>{
      this.time = new Date(e.data().time.toDate()).getTime();
      this.diasbleCountDown = new Date().getTime() > this.time;
      let countDown2 = this.time
      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
  
      this.x2 = setInterval(() => {
  
        let now2 = new Date().getTime(),
          distance2 = countDown2 - now2;
  
        let d2 = Math.floor(distance2 / (day));
        let h2 = Math.floor((distance2 % (day)) / (hour));
        let m2 = Math.floor((distance2 % (hour)) / (minute));
        let s2 = Math.floor((distance2 % (minute)) / second);
  
        this.counttimer2 = ('0' + d2).slice(-2) + ' days ' + ('0' + h2).slice(-2) + ' hours ' + ('0' + m2).slice(-2) + ' mins ' + ('0' + s2).slice(-2) + ' secs '
  
        if (distance2 < 0) {
          clearInterval(this.x2);
          this.counttimer2 = ''
        }
      }, second)
    })

    this.userinfoSrv.currentRole.subscribe(role => this.role = role);

   


    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.angularFireAuth.authState.subscribe(async authState => {
      if (authState) {
        this.login = true;

        await this.firestore.collection('Admin').doc(authState.uid).get().forEach(async e => {
          if (e.exists) {
            const role = [];
            role.push(e.data().Role);
            const snapshot = await this.firestore.collection('Users').doc(authState.uid).get();
            snapshot.forEach(e => {
              if (e.exists)
                role.push('User')

              this.userinfoSrv.SetRole(role)
            })

          } else {
            if (authState.emailVerified) {
              const snapshot = await this.firestore.collection('Users').doc(authState.uid).get();
              snapshot.forEach(e => {
                if (e.exists) {
                  this.userinfoSrv.SetRole(['User'])
                  this.userinfoSrv.ic = e.data().IC;
                }
                else {
                  this.angularFireAuth.auth.signOut();
                }
              })
            }
          }
        });
      }
      this.ready = true;

    });
  }
  private dateFormat = new DateFormatService();

  visitorList = []

  async ngOnInit() {

    const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());

    await this.firestore.collection('Visitor').doc(dateFormat).get().forEach(e => {
      if (e.exists) {
        this.firestore.collection('Visitor').doc(dateFormat).update({ count: e.data().count + 1 })
      } else {
        this.firestore.collection('Visitor').doc(dateFormat).set({ count: 1 })
      }
    })
  }
  logout() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '300px';
    const position = {
      top: '15%'
    };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Log out? ';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(result => {
      if (result) {
        this.angularFireAuth.auth.signOut();
        this.login = false;
        this.userinfoSrv.SetRole([])
        this.router.navigate(['/']);
      }
    })


  }

  redirect(link) {
    window.open(link, "_blank");
  }

  changePassword(){
      this.dialog.open(AccountSettingsComponent, {
        width: '70%',
        disableClose: true,
        position: {
          top: '10%'
        }
      })
  }
}
